/* Standalone progressive enhancement. Native swipe and controls work without JS. */
(() => {
  document.querySelectorAll('.wk-gallery-editorial[data-wk-gallery]').forEach(gallery => {
    if (gallery.dataset.enhanced) return;
    const track = gallery.querySelector('[data-gallery-track]');
    const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
    const buttons = [...gallery.querySelectorAll('[data-gallery-go]')];
    const nav = gallery.querySelector('[data-gallery-nav]');
    const previous = gallery.querySelector('[data-gallery-prev]');
    const next = gallery.querySelector('[data-gallery-next]');
    const count = gallery.querySelector('[data-gallery-count]');
    const thumbnails = gallery.querySelector('.wk-gallery-thumbnails');
    if (!track || !nav || !previous || !next || !count || !thumbnails || !slides.length || slides.length !== buttons.length) return;

    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const behavior = () => motion.matches ? 'auto' : 'smooth';
    // Bounding rectangles retain fractional pixels and include real layout gaps.
    const offset = slide => slide.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft - track.clientLeft;
    const nearest = () => slides.reduce((best, slide, index) =>
      Math.abs(offset(slide) - track.scrollLeft) < Math.abs(offset(slides[best]) - track.scrollLeft) ? index : best, 0);
    let selected = nearest();
    let destination = null;
    let timer;

    const pauseExcept = index => slides.forEach((slide, i) => {
      if (i !== index) slide.querySelectorAll('video').forEach(video => video.pause());
    });
    const revealThumbnail = index => {
      const button = buttons[index];
      const bounds = button.getBoundingClientRect();
      const strip = thumbnails.getBoundingClientRect();
      const left = bounds.left - strip.left + thumbnails.scrollLeft;
      if (bounds.left < strip.left + 3) thumbnails.scrollTo({left: Math.max(0, left - 3), behavior: behavior()});
      else if (bounds.right > strip.right - 3) thumbnails.scrollTo({left: left + bounds.width - thumbnails.clientWidth + 3, behavior: behavior()});
    };
    const select = index => {
      selected = index;
      buttons.forEach((button, i) => button.setAttribute('aria-current', String(i === index)));
      slides.forEach((slide, i) => { slide.inert = i !== index; });
      previous.disabled = index === 0;
      next.disabled = index === slides.length - 1;
      const value = `${index + 1} / ${slides.length}`;
      if (count.textContent !== value) count.textContent = value;
      pauseExcept(index);
    };
    const settle = () => {
      clearTimeout(timer);
      destination = null;
      select(nearest());
      revealThumbnail(selected);
    };
    const go = index => {
      destination = Math.max(0, Math.min(slides.length - 1, index));
      select(destination);
      revealThumbnail(destination);
      track.scrollTo({left: offset(slides[destination]), behavior: behavior()});
      clearTimeout(timer);
      timer = setTimeout(settle, 160);
    };

    buttons.forEach((button, index) => button.addEventListener('click', () => go(index)));
    previous.addEventListener('click', () => go((destination ?? selected) - 1));
    next.addEventListener('click', () => go((destination ?? selected) + 1));
    track.addEventListener('scroll', () => {
      // A native swipe must stop a departing video too, not only button clicks.
      pauseExcept(nearest());
      clearTimeout(timer);
      timer = setTimeout(settle, 160);
    }, {passive: true});
    track.addEventListener('scrollend', settle);
    track.addEventListener('pointerdown', () => { destination = null; }, {passive: true});
    gallery.addEventListener('keydown', event => {
      // Keep native video seeking, volume and fullscreen keyboard controls intact.
      if (event.altKey || event.ctrlKey || event.metaKey || event.target.closest('video, input, select, textarea, [contenteditable="true"]')) return;
      const current = destination ?? nearest();
      const targets = {ArrowRight: current + 1, ArrowLeft: current - 1, Home: 0, End: slides.length - 1};
      if (targets[event.key] !== undefined) {
        event.preventDefault();
        go(targets[event.key]);
      }
    });
    const realign = () => {
      clearTimeout(timer);
      destination = null;
      track.scrollTo({left: offset(slides[selected]), behavior: 'auto'});
      revealThumbnail(selected);
    };
    if ('ResizeObserver' in window) new ResizeObserver(realign).observe(track);
    else window.addEventListener('resize', realign, {passive: true});
    window.addEventListener('pagehide', () => pauseExcept(-1));
    document.addEventListener('visibilitychange', () => { if (document.hidden) pauseExcept(-1); });
    gallery.dataset.enhanced = 'true';
    nav.hidden = false;
    select(selected);
  });
})();
